import Loadable from 'react-loadable';

import {
  NOT_FOUND_PAGE_LINK,
  PROPERTIES_PAGE_LINK,
  SHARED_FILTER_RESULT_PAGE_LINK,
  PROPERTIES_SHARE_RESULT_PAGE_LINK,
  CREATE_SESSION_PAGE_LINK,
  UPDATE_SESSION_PAGE_LINK,
  SESSIONS_PAGE_LINK,
} from '../commons/constants';

const LoadableLoading = () => <></>;
const loadable = (
  loader: () => Promise<React.ComponentType<any> | { default: React.ComponentType<any> }>
) =>
  Loadable({
    loader,
    delay: false,
    loading: LoadableLoading,
  });

export default {
  // default pages
  [NOT_FOUND_PAGE_LINK]: {
    component: loadable(() => import('../pages/NotFoundPage')),
    requiredAuth: true,
  },

  // properties page
  [PROPERTIES_PAGE_LINK]: {
    component: loadable(() => import('../pages/PropertiesPage')),
    requiredAuth: true,
  },

  // session page
  [CREATE_SESSION_PAGE_LINK]: {
    component: loadable(() => import('../pages/SessionPage')),
    requiredAuth: true,
  },
  [UPDATE_SESSION_PAGE_LINK]: {
    component: loadable(() => import('../pages/SessionPage')),
    requiredAuth: true,
  },
  [SESSIONS_PAGE_LINK]: {
    component: loadable(() => import('../pages/SessionsPage')),
    requiredAuth: true,
  },

  [SHARED_FILTER_RESULT_PAGE_LINK]: {
    component: loadable(() => import('../pages/SharedFilterResultPage')),
    requiredAuth: true,
  },

  [PROPERTIES_SHARE_RESULT_PAGE_LINK]: {
    component: loadable(() => import('../pages/ShareResultPage')),
    requiredAuth: false,
  },
};
